var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    {
      class: _vm.fieldClass,
      attrs: {
        inline: _vm.inline,
        clearable: _vm.clearable,
        togglePassword: _vm.togglePassword
      }
    },
    [
      _vm.label
        ? _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c("md-input", {
        ref: _vm.name,
        class: "text-align-" + _vm.align,
        attrs: {
          id: _vm.id,
          type: _vm.type,
          name: _vm.name,
          value: _vm.value,
          counter: _vm.counter,
          required: _vm.required,
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          placeholder: _vm.placeholder,
          readonly: _vm.readonly,
          step: _vm.step,
          autocomplete: _vm.autocomplete ? "on" : "off"
        },
        on: {
          input: _vm.onInput,
          blur: _vm.onBlur2,
          focus: _vm.onFocus2,
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.onEnterKeypress.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.errorMessage))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.focus
        ? _c(
            "div",
            { staticClass: "absoulte" },
            [
              _vm._l(_vm.formattedList, function(el) {
                return _c(
                  "p",
                  {
                    key: el + "-list",
                    on: {
                      click: function($event) {
                        return _vm.setValue(el)
                      }
                    }
                  },
                  [_vm._v(_vm._s(el))]
                )
              }),
              _vm._v(" "),
              !_vm.formattedList.length
                ? _c("p", [
                    _vm._v(
                      _vm._s(this.value) + " (" + _vm._s(_vm.secLabel) + ")"
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b7c8f3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b7c8f3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/fields/InputField2.vue
// module id = YpWh
// module chunks = 1